export const ReportConstants = {
  uselocalJOSN: false,
  displayInputJson: false,
  googleApiKey: 'AIzaSyAwXZ7UVeJXSJrFoSj7JyQlTcSwE5G3njQ',
};
